import api from "./api";
import {iniciarRequisicao} from "../helpers/index.js";

class UtilitariosAPI {
    async getProdutosSobDemanda(headers, params){
      const response = await api.post("/get_produtos_sob_demanda", params, {headers});
      return response;
    }

    async pingNoServidor(baseURL) {
      const headers = iniciarRequisicao()
      return await api({
        method: 'get',
        baseURL: `${baseURL}/api`,
        url: '/ping',
        headers,
      });
    }
}

export default new UtilitariosAPI();
